<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <template v-if="verTema">
      <v-row>
        <v-col cols="12">
          <ButtonComp @click="$emit('close')" classColor="red" text-button="Volver"
            icon-but="fas fa-arrow-alt-circle-left" normalButton />
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col>
              <textfieldComp :value="listUnidad.desc_nivel" textLabel="Nivel" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_grado" textLabel="Grado" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_area" textLabel="Area" readonly />
            </v-col>
            <v-col>
              <textfieldComp :value="listUnidad.desc_curso" textLabel="Curso" readonly />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" class="d-flex  justify-end">
          <ButtonComp @click="AddItem(listUnidad)" textButton="Crear tema" iconBut="fas fa-plus" normalButton />
        </v-col>
        <v-col cols="12">
          <ComundataTablecomp :headers="GestionContenidoVisorTemasHeaders" :items="listTema">
            <template v-slot>
              <v-chip label color="primary">
                UNIDAD: {{ listUnidad.nombre_tema }}
              </v-chip>
            </template>
            <template v-slot:fecha="{ item }">
              {{ item.fecha_ingreso | filtroFecha }}
            </template>

            <template v-slot:edit="{ item }">
              <ButtonComp @click="EditItem(listUnidad, item)" edit-button tooltip-text="Editar nombre del tema" />
            </template>

            <template v-slot:view="{ item }">
              <ButtonComp @click="ViewDiapositivas(item); visclas = false;" ver-button tooltip-text="Ver diapositiva" />
            </template>

            <template v-slot:view_somos_habiles="{ item }">
              <ButtonComp @click="ViewSomosHabiles(item); visclas = false;" add-button
                tooltip-text="Crear somos hábiles" />
            </template>

            <template v-slot:view_diapo="{ item }">
              <ButtonComp @click="ListContenido(item)" icon-but="fas fa-file-signature" class-color="orange"
                tooltipText="Crear diapositivas" />
            </template>

            <!-- cuaderno de trabajo -->
            <!-- <template v-slot:cuaderno="{ item }">

              <ButtonComp v-if="item.cuaderno_trabajo === '' || item.cuaderno_trabajo === null" @click="AddCuaderno(item)"
                upload-button tooltip-text="Subir cuaderno de actividades" />

              <v-menu offset-y v-if="item.cuaderno_trabajo">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp tooltip-text="Opciones cuaderno de actividades" class-color="primary"
                      icon-but="fas fa-book-reader" />
                  </div>
                </template>
                <v-list class="d-flex justify-center">
                  <v-list-item>
                    <ButtonComp @click="Download(URL_SPACE + '/' + item.cuaderno_trabajo)" icon-but="fas fa-file-word"
                      tooltipText="Descargar cuaderno de actividades" classColor="primary" />
                  </v-list-item>
                  <v-list-item>
                    <ButtonComp @click="eventDeleteCuaderno(item)" deleteButton
                      tooltipText="Eliminar cuaderno de actividades" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </template> -->

            <!-- nueva versión  -->
            <template v-slot:cuaderno="{ item }">

              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp tooltip-text="Opciones cuaderno de actividades" class-color="primary"
                      icon-but="fas fa-book-reader" />
                  </div>
                </template>


                <v-list dense>
                  <!-- grupo items del docente -->
                  <v-list-item-group>
                    <!-- título del item -->
                    <v-list>
                      <v-list-item-content class="text-center">
                        <v-list-item-title>Docente</v-list-item-title>
                      </v-list-item-content>
                    </v-list>
                    <!--condicional en caso haya un cuaderno del docente -->
                    <v-list class="d-flex justify-center" v-if="item.cuaderno_trabajo_docente">
                      <v-list-item>
                        <ButtonComp @click="Download(URL_SPACE + '/' + item.cuaderno_trabajo_docente)" icon-but="fas fa-file-word"
                          tooltipText="Descargar cuaderno de actividades del docente" classColor="primary" />
                      </v-list-item>
                      <v-list-item>
                        <ButtonComp @click="eventDeleteCuaderno(item, 'cuaderno_trabajo_docente')" deleteButton
                          tooltipText="Eliminar cuaderno de actividades del docente" />
                      </v-list-item>
                    </v-list>
                    <!--condicional en caso no haya contenido -->
                    <v-list v-if="item.cuaderno_trabajo_docente === '' || item.cuaderno_trabajo_docente === null">
                      <v-list-item>
                        <ButtonComp  @click="AddCuaderno(item, 'cuaderno_trabajo_docente')"
                          upload-button tooltip-text="Subir cuaderno de actividades del docente" />
                      </v-list-item>
                    </v-list>
                  </v-list-item-group>
                  <!-- grupo items del estudiante -->
                   <v-list-item-group>
                    <v-list>
                       <v-list-item-content class="text-center">
                         <v-list-item-title>Estudiante</v-list-item-title>
                       </v-list-item-content>
                     </v-list>
                     <!-- condicional en caso haya archivo -->
                     <v-list class="d-flex justify-center" v-if="item.cuaderno_trabajo">
                        <v-list-item>
                          <ButtonComp @click="Download(URL_SPACE + '/' + item.cuaderno_trabajo)" icon-but="fas fa-file-word"
                            tooltipText="Descargar cuaderno de actividades del estudiante" classColor="primary" />
                        </v-list-item>
                        <v-list-item>
                          <ButtonComp @click="eventDeleteCuaderno(item, 'cuaderno_trabajo')" deleteButton
                            tooltipText="Eliminar cuaderno de actividades del estudiante" />
                        </v-list-item>
                      </v-list>
                      <!-- condicional en caso no haya un archivo -->
                      <v-list v-if="item.cuaderno_trabajo === '' || item.cuaderno_trabajo === null">
                        <v-list-item>
                          <ButtonComp  @click="AddCuaderno(item, 'cuaderno_trabajo')"
                            upload-button tooltip-text="Subir cuaderno de actividades del estudiante" />
                        </v-list-item>
                      </v-list>
                   </v-list-item-group>
                </v-list>

              </v-menu>
            </template>


            <template v-slot:session_a="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <ButtonComp iconBut="fas fa-file" class-color="teal" tooltip-text="Sesión de aprendizaje" />
                  </div>
                </template>
                <v-list class="d-flex justify-center">
                  <v-list-item v-if="item.id_sa == '' || item.id_sa == null">
                    <ButtonComp @click="LoadSessionAprendizaje('add', item)" icon-but="fas fa-plus-circle"
                      tooltip-text="Crear sesión" class-color="primary" />
                  </v-list-item>
                  <v-list-item v-else>
                    <ButtonComp @click="LoadSessionAprendizaje('edit', item)" edit-button tooltip-text="Editar sesión" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:delete="{ item }">
              <ButtonComp @click="ShowConfirmDeleteClase(item)" deleteButton tooltipText="Eliminar tema" />
            </template>
          </ComundataTablecomp>
        </v-col>

      </v-row>
    </template>

    <!-- modal cargar cuaderno de trabajo -->
    <v-dialog v-model="modal_cuaderno" persistent scrollable max-width="500px">
      <v-card>
        <v-card-title class="btn_otro">
          <span>Agregar cuaderno de actividades</span>
          <v-spacer></v-spacer>
          <v-btn fab dark x-small class="btn_style3" @click="CloseCuaderno">
            <v-icon dark>fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-12 pb-8">
          <v-file-input v-model="selectedFile" show-size label="Seleccionar cuaderno de actividades"
            accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.csv,.txt" @change="CargarPrevia" ref="myFileInput" clearable
            dense counter prepend-icon="mdi-file" style="max-width: 400px"></v-file-input>

          <br />

          <div class="pl-1">
            <span v-if="!nombreArchivo" class="my-text text--error py-2">
              <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
              Ningún archivo seleccionado
            </span>
            <span v-else class="my-text text--success py-2">
              <v-icon color="success" small>mdi-check-circle-outline</v-icon>
              Archivo seleccionado
            </span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="subiendoCuaderno" :disabled="!existeArchivo" @click="SubmitFileCuaderno" color="primary"
            class="px-3">
            <v-icon left>fas fa-save</v-icon>
            Guardar cuaderno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Confirm title="¿Está seguro de que desea eliminar este registro?" :active="confirmDeleteClase" @aceptar="DeleteClass"
      @cancelar="CerrarConfirmDeleteClase" />

    <Confirm title="¿Está seguro de que desea eliminar este registro?" :active="confirmDeleteCuaderno"
      @aceptar="DeleteCuaderno" @cancelar="CerrarConfirmDeleteCuaderno" />
    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations } from "vuex";
import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import Confirm from "@/components/confirm";
import TemaFormComp from "./componentes/temaFormComp";
import ListContenidoComp from "../creadorContenido/contenido";
import SesionAprendizaje from "../sesionAprendizaje/sesionAprendizaje.vue";
import BalotarioComp from "../creadorSomosHabiles/balotarioSomosHabilies";
import VisorContenido from "@/views/Manager/GestionContenido/viewGC/visorGestorContenido";
import textfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';
import { GestionContenidoVisorTemasHeaders } from "../../../../helpers/headersTable";
// import visorGestorContenidoColegioVue from '../viewGC/visorGestorContenidoColegio.vue';

export default {
  name: "Tema",
  // componentes
  components: {
    Confirm,
    TemaFormComp,
    ListContenidoComp,
    SesionAprendizaje,
    VisorContenido,
    BalotarioComp,
    BtnComp,
    ButtonComp,
    ComundataTablecomp,
    textfieldComp,
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  data() {
    return {
      mensaje: { tipo: null, mensaje: null, tiempo: null }, // mensaje de sistema
      ruta_api: API_URL,
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      test: false,
      // componente Fomulario
      compName: null,
      estadoComponente: true,
      parametroComp: [],
      nombreArchivo: "",
      subiendoCuaderno: false,
      GestionContenidoVisorTemasHeaders,

      verTema: true,

      itemDelete: "",
      cuadernoToAlter: "",
      confirmDeleteClase: false,
      confirmDeleteCuaderno: false,

      listUnidad: {},
      listTema: [],

      arrayCuaderno: {},
      modal_cuaderno: false,
      existeArchivo: false,

      search: "",



      dialog: false,
      agregar: false,
      editar: false,
      editedIndex: -1,
      errorTema: false,
      menssageError: "",

      datosTema: {},
      totalTemas: 1,
      sesionAprendizaje: { id: null },

      selectedFile: null,

      //validaciones de formulario
      rul: {
        required: (value) => !!value || "Campo Requerido",
        inputReq: (value) => !!value || "Campo Requerido",
        selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
        email: (value) =>
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
          "El correo Electrónico es incorrecto",
        min4: (v) => (v || "").length >= 4 || "MÃ­nimo 4 caracteres",
        min6: (v) => (v || "").length >= 6 || "MÃ­nimo 6 caracteres",
        min8: (v) => (v || "").length >= 8 || "MÃ­nimo 8 caracteres",
        max10: (v) => (v || "").length <= 10 || "MÃ¡ximo 10 caracteres",
        max11: (v) => (v || "").length <= 11 || "MÃ¡ximo 11 caracteres",
        max12: (v) => (v || "").length <= 12 || "MÃ¡ximo 12 caracteres",
        max20: (v) => (v || "").length <= 20 || "MÃ¡ximo 20 caracteres",
        max30: (v) => (v || "").length <= 30 || "MÃ¡ximo 30 caracteres",
        max50: (v) => (v || "").length <= 50 || "MÃ¡ximo 50 caracteres",
        max60: (v) => (v || "").length <= 60 || "MÃ¡ximo 60 caracteres",
        max100: (v) => (v || "").length <= 100 || "MÃ¡ximo 100 caracteres",
        max150: (v) => (v || "").length <= 150 || "MÃ¡ximo 150 caracteres",

        email_null: (value) => {
          if (value == "") {
            return false;
          } else {
            const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
            return pattern.test(value) || "El correo Electrónico es incorrecto";
          }
        },
      },
    };
  },

  /// variables computadas
  computed: {
    titleModalTema() {
      return this.editar !== true ? "Crear Unidad" : "Editar Unidad";
    },
  },

  mounted() {
    this.LoadMain();
  },

  watch: {
    // cada vez que la pregunta cambie, esta función sera ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.verTema = true;
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.verTema = false;
        this.LimpiarForm();
      }
    },
  },

  methods: {
    eventDeleteCuaderno(item, cuadernoToDelete) {
      this.confirmDeleteCuaderno = true;
      this.itemDelete = item;
      this.cuadernoToAlter = cuadernoToDelete;
    },
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- cargar Parametros de inicio del componente --
    async LoadMain() {
      this.listUnidad = this.parametros.item;
      this.GetTema();
    },
    ///////////////////////////////////////////////////////////

    async GetTema() {
      let params = {
        id_nivel: this.listUnidad.id_nivel,
        id_grado: this.listUnidad.id_grado,
        id_area: this.listUnidad.id_area,
        id_curso: this.listUnidad.id_curso,
        id_tema: this.listUnidad.id,
      };

      const resp = await axios.post("/manager/clase/lista/", params);
      this.listTema = resp.data.payload;
    },

    AddItem(unidad) {
      //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
      this.parametroComp = { evento: "add", unidad };
      this.compName = "TemaFormComp";
      this.estadoComponente = true;
    },

    EditItem(unidad, item) {
      // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
      this.parametroComp = { evento: "edit", unidad, item };
      this.compName = "TemaFormComp";
      this.estadoComponente = true;
    },

    ListContenido(item) {
      this.verTema = false;
      this.parametroComp = { evento: "view", item };
      this.compName = "ListContenidoComp";
      this.estadoComponente = true;
    },

    async DeleteClass() {
      try {
        let resp = await axios.put("/manager/clase/dt/inac/" + this.itemDelete + "");
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
        this.CerrarConfirmDeleteClase();
        this.GetTema();
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Ha ocurrido un error , por favor intente nuevamente",
          tiempo: null,
        });
      }
    },

    ShowConfirmDeleteClase(item) {
      this.confirmDeleteClase = true;
      this.itemDelete = item.id_clase;
    },

    CerrarConfirmDeleteClase() {
      this.confirmDeleteClase = false;
      this.itemDelete = "";
      this.cuadernoToAlter = "";
    },

    AddCuaderno(item, tipoCuadernoToAdd) {
      this.modal_cuaderno = true;
      this.arrayCuaderno.id_nivel = item.id_nivel;
      this.arrayCuaderno.id_grado = item.id_grado;
      this.arrayCuaderno.id_curso = item.id_curso;
      this.arrayCuaderno.id_tema = item.id;
      this.arrayCuaderno.id_area = item.id_area;
      this.arrayCuaderno.id_clase = item.id_clase;
      this.cuadernoToAlter = tipoCuadernoToAdd;
    },

    CloseCuaderno() {
      this.modal_cuaderno = false;
      this.existeArchivo = false;
      this.arrayCuaderno = {};
      this.nombreArchivo = null; // Aquí solo necesitas poner a null el modelo
      this.cuadernoToAlter = "";
      this.$refs.myFileInput.reset();
    },

    CargarPrevia(file) {
      this.nombreArchivo = file; // Aquí file es el archivo seleccionado en v-file-input
     
      if (this.nombreArchivo) {
        this.existeArchivo = true;
      }
    },

    async SubmitFileCuaderno() {
      this.subiendoCuaderno = true; //animacion de loadin del btn
      let formData = new FormData();
      formData.append("subirArchivo", this.nombreArchivo);
      formData.append("id_nivel", this.listUnidad.id_nivel);
      formData.append("id_grado", this.listUnidad.id_grado);
      formData.append("id_tema", this.listUnidad.id);
      formData.append("id_curso", this.arrayCuaderno.id_curso);
      formData.append("id_area", this.arrayCuaderno.id_area);
      formData.append("id_clase", this.arrayCuaderno.id_clase);
      formData.append("cuadernoPerfil", this.cuadernoToAlter);

      try {
        let response = await axios.post("/archivo/cuadernoTrabCK1Add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        await this.AddCuadernoTrabajo(response.data);
        // this.nombreArchivo = null;  // Limpia el archivo seleccionado
        // this.$refs.myFileInput.value = '';
        //this.mensaje_sesion = true
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Ha ocurrido un error , por favor intente nuevamente",
          tiempo: null,
        });
      }
    },

    async AddCuadernoTrabajo(response) {
      let paramCuaderno = {
        id_usuario: sessionStorage.id,
        // cuaderno_trabajo: `${response.uri}${response.nombreArchivo}`,
      };

      paramCuaderno[this.cuadernoToAlter] = `${response.uri}${response.nombreArchivo}`;
      
      try {
        let res = await axios.put(
          `/manager/clase/cuadernoTrabajo/${this.arrayCuaderno.id_clase}`,
          paramCuaderno
        );
        if (res.data.messageT == "S") {
          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Tu cuaderno de actividades fue cargado correctamente!",
            tiempo: null,
          });
          this.subiendoCuaderno = false; // termina la animacion
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: "Ocurrió un error al guardar su cuaderno",
            tiempo: null,
          });
        }

        // this.actualizar(this.elTema.id_tema);
        this.LoadMain();
        setTimeout(() => {
          this.CloseCuaderno();
        }, 700);
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Ha ocurrido un error , por favor intente nuevamente",
          tiempo: null,
        });
      }
    },

    async Download(url) {
      const _url = url.split("/");

      // para identificar si es una ruta
      const isOld = url.includes("undefined");

      try {
        let response;
        // si es para los cuadernos antiguos debe seguir este flujo
        if (isOld) {
          response = await axios.get(url);
        } else {
          // sino debe seguir en el space
          response = await fetch(url);
        }

        if (response) {
          // Para entender mejor esto pueden leer el archivo file.js
          const funcionDescarga = isOld ? "dowload" : "downloadFetch";
          this.$Files[funcionDescarga]({ url: url, filename: _url[_url.length - 1] });
        }
      } catch (error) {
        if (error) {
          let resp = error.response.data;
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: ` ${resp.message}`,
            tiempo: null,
          });
        }
      }
    },

    ViewSomosHabiles(item) {
      this.verTema = false;
      this.parametroComp = { evento: "view", item };
      this.compName = "BalotarioComp";
      this.estadoComponente = true;
    },
    // ESTA FUNCION ABRE LA VISTA PARA VER LAs DIAPOSITIVAs
    ViewDiapositivas(item) {

      // this.setEnviarMens({tipo: 'W', mensaje: `ViewDiapositivas en construccion visor new 2023 `, tiempo:null})
      const datosMiniatura = Object.assign(item, {
        evento: "agregar",
        miniatura: false,
        id_diapositiva: 1,
        tipo_contenido: "manager",
        // SE LE TIENE QUE INDICAR EL TIPO PARA SABER QUE CONTENIDO LLAMAR
        // visorGestorContenidoColegio.vue
      });

      this.compName = "VisorContenido";
      this.estadoComponente = true;
      this.parametroComp = datosMiniatura;
    },

    LoadSessionAprendizaje(evento, item) {
      this.parametroComp = {
        id_clase: item.id_clase,
        evento,
        totalTemas: this.listTema.length,
        tema: item,
      };
      setTimeout(() => {
        this.compName = "SesionAprendizaje";
        this.estadoComponente = true;
      }, "500");
    },

    CloseModal() {
      this.estadoComponente = false;
      this.verTema = true;
      this.LoadMain();
    },

    ///////////////////////////////////////////////////////////////
    async DeleteCuaderno() {
      let paramCuaderno = {
        id_usuario: sessionStorage.id,
        ruta: this.itemDelete[this.cuadernoToAlter]
      };

      // this.cuadernoToDelete tiene que ser "cuaderno_trabajo" o "cuaderno_trabajo_docente"
      paramCuaderno[this.cuadernoToAlter] = null;

      // let params = {
      //   // ruta: this.itemDelete.cuaderno_trabajo,
      // };

      // if(this.cuadernoToAlter == "cuaderno_trabajo") this.itemDelete.cuaderno_trabajo
      // if(this.cuadernoToAlter == "cuaderno_trabajo_docente") this.itemDelete.cuaderno_trabajo_docente

      try {
        let res = await axios.put(
          `/manager/clase/cuadernoTrabajo/${this.itemDelete.id_clase}`,
          paramCuaderno
        );
        if (res.data.messageT === "S") {
        //   let response = await axios.post("/archivo/delete/", params);
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: "¡Información eliminada con éxito.!",
            tiempo: null,
          });
        }
        this.confirmDeleteCuaderno = false;
        this.cuadernoToAlter = "";
        this.LoadMain();
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Ha ocurrido un error , por favor intente nuevamente",
          tiempo: null,
        });
      }
    },

    CerrarConfirmDeleteCuaderno() {
      this.confirmDeleteCuaderno = false;
      this.itemDelete = "";
      this.existeArchivo = false;
      this.cuadernoToAlter = "";
    },

    LimpiarForm() { },
  },
};
</script>

<style scoped>
.my-text.text--error {
  color: var(--v-error-base) !important;
}

.my-text.text--success {
  color: var(--v-success-base) !important;
}
</style>
